<template>
    <div class="modals-container">
        <component
            :is="modal.component"
            v-for="(modal, index) in modals"
            :key="index"
            :index="index"
            :name="modal.name"
            v-on="modal.on"
            v-bind="modal.bind"
            v-model="modal.modelValue"
            @open-modal="updateOverflows(true)"
            @close-modal="updateOverflows(false)"
            @closed="remove(index)"
            :data-padding="getWidthScrollbar()"
        >
            <template v-for="(slot, key) in modal.slots" #[key] :key="key">
                <div v-if="isString(slot)" v-html="slot" />
                <component
                    :is="slot.component"
                    v-else-if="'component' in slot"
                    v-bind="slot.bind"
                />
                <component
                    :is="slot"
                    v-else
                />
            </template>
        </component>
    </div>
</template>

<script>
export default {
    name: 'modals-container',
}
</script>

<script setup>
import { onMounted, inject } from 'vue';

const isString = value => typeof value === 'string';

const modals = inject('modalsApi').modals;
const body = document.querySelector('body');

onMounted(() => {
    window.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && modals.length) {
            modals[modals.length - 1].modelValue = false;
        }
    })
});

const updateOverflows = (value) => {
    if (value) {
        body.style.paddingRight = `${getWidthScrollbar()}px`;
        body.classList.add('is-modal');
        return;
    }
}

const getWidthScrollbar = () => {
    const documentWidth = document.documentElement.clientWidth
    return Math.abs(window.innerWidth - documentWidth)
}

const remove = (index) => {
    modals.splice(index, 1);

    if (modals.length == 0) {
        body.style.paddingRight = '';
        body.classList.remove('is-modal');
    }
}
</script>